// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"b4da8904","425":"7a2843c4","510":"1c9be205","532":"414d80e7","633":"633484d2","634":"1f4cb069","922":"13d2c689","937":"4032c276","972":"84740209"}[chunkId] + ".chunk.js";
};